import { render, staticRenderFns } from "./DialogoExibirAgendamento.vue?vue&type=template&id=73287472&scoped=true&"
import script from "./DialogoExibirAgendamento.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoExibirAgendamento.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73287472",
  null
  
)

export default component.exports